import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { Navigation } from 'swiper/modules';
import { createEmptyCart, addProductToCart, getProducts } from './utils/graphql';
import { getMindboxPrices } from './utils/mindbox';

let cartQuantity = 0;

$.widget('photoderm.products', {
	options: {
		selectors: {
			productsSlider1: '[data-role=products-slider-1]',
			productsSlider2: '[data-role=products-slider-2]',
			chooseSunscreenInner3: '[data-role=choose-sunscreen-inner-3]',
			chooseSunscreenMain: '[data-role=choose-sunscreen-main]',
			chooseSunscreenPrev: '[data-role=choose-sunscreen-prev]',
			chooseSunscreenNext: '[data-role=choose-sunscreen-next]',
			productsSlider3: '[data-role=products-slider-3]',
			addToCart: '[data-role=add-to-cart]',
			counter: '[data-role=cart-counter]',
			productName: '[data-role=product-name]',
			product: '[data-role=product]',
			productPrice: '[data-role=product-price]',
			regularPrice: '[data-role=regular-price]',
			oldPrice: '[data-role=old-price]',
			productImage: '[data-role=product-image]',
			productNotification: '[data-role=notification]',
			nextButton: '[data-role=next-button]',
			prevButton: '[data-role=prev-button]',
			otherProductsOfGamma: '[data-role=other-products-of-gamma]',
			closeButton: '[data-role=close-button]',
			productsSlider: '[data-role=products-slider]'
		},
		classes: {
			active: '_active',
			show: '_show'
		},
	},

	_create() {
		this._sliderInstances = [];
		this._pricesCache = {};
		this._bind();
	},

	_bind() {
		this._cache();
		this._events();
		this.initSliders();
		this._bindSlidersResize();
		this.getProductsPrice();
	},

	_bindSlidersResize() {
		let timer;
		$(window).on('resize', () => {
			clearTimeout(timer);
			timer = setTimeout(() => this.initSliders(), 200);
		});
	},

	_destroyAllSliders() {
		(this._sliderInstances || []).forEach((s) => {
			if (s && typeof s.destroy === 'function') {
				try {
					s.destroy(true, true);
				} catch (e) {
					// ignore
				}
			}
		});
		this._sliderInstances = [];
	},

	_events() {
		this._on(this.$addTocart, {
			click: this.onAddToCartClick,
		});

		this._on(this.$closeButton, {
			click: this.onCloseButtonClick,
		});

		this._on(this.$product,  {
			click: (event) => {
				if (!event.target.closest('[data-role=add-to-cart]')) {
					const onclick = Function(event.currentTarget.dataset.onclick);
					onclick();
				}
			},
		});
	},

	formatPrice(price) {
		return price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' ₽';
	},

	_cache() {
		const { selectors } = this.options;

		this.$element = $(this.element);
		this.$otherProductsOfGamma = $(selectors.otherProductsOfGamma);
		this.$productsSlider1 = this.$element.find(selectors.productsSlider1)[0];
		this.$productsSlider2 = this.$element.find(selectors.productsSlider2)[0];
		this.$chooseSunscreenInner3 = this.$element.find(selectors.chooseSunscreenInner3)[0];
		this.$chooseSunscreenMain = this.$element.find(selectors.chooseSunscreenMain)[0];
		this.$productsSlider3 = this.$otherProductsOfGamma.find(selectors.productsSlider3)[0];
		this.$productsSlider = $(selectors.productsSlider);
		this.$product = $(selectors.product);
		// Важно: собираем кнопки добавления в корзину глобально, чтобы охватить все блоки
		this.$addTocart = $(selectors.addToCart);
		this.$counter = $(selectors.counter);
		this.$productName = $(selectors.productName);
		this.$productImage = $(selectors.productImage);
		this.$productNotification = $(selectors.productNotification);
		this.$productRegularPrice = this.$productNotification.find(selectors.regularPrice);
		this.$productOldPrice = this.$productNotification.find(selectors.oldPrice);
		this.$closeButton = $(selectors.closeButton);
	},

	initSliders() {
		this._destroyAllSliders();
		const isMobile = $(window).width() <= 768;

		if (isMobile) {
			this.initProductsSlider(this.$productsSlider1, 1.18);
			this.initProductsSlider(this.$productsSlider2, 1.18);
			this.initProductsSlider(this.$chooseSunscreenInner3, 1.18);
			this.initProductsSlider(this.$productsSlider3, 1.4);
		} else {
			this.initChooseSunscreenMainSlider();
		}
	},

	initChooseSunscreenMainSlider() {
		const { chooseSunscreenPrev, chooseSunscreenNext } = this.options.selectors;
		if (!this.$chooseSunscreenMain) {
			return;
		}
		const instance = new Swiper(this.$chooseSunscreenMain, {
			modules: [Navigation],
			loop: false,
			slidesPerView: 2,
			spaceBetween: 16,
			watchOverflow: true,
			navigation: {
				nextEl: this.$element.find(chooseSunscreenNext)[0],
				prevEl: this.$element.find(chooseSunscreenPrev)[0],
			},
			breakpoints: {
				1025: {
					spaceBetween: 24,
				},
				1201: {
					spaceBetween: 40,
				},
			},
		});
		this._sliderInstances.push(instance);
	},

	initProductsSlider($products, slidesPerView) {
		if (!$products) {
			return null;
		}
		const $wrap = $($products);
		let nextBtn = $wrap.find(this.options.selectors.nextButton)[0];
		let prevBtn = $wrap.find(this.options.selectors.prevButton)[0];
		if (!nextBtn || !prevBtn) {
			const $root = $wrap.closest(this.options.selectors.productsSlider);
			nextBtn = nextBtn || $root.find(this.options.selectors.nextButton)[0];
			prevBtn = prevBtn || $root.find(this.options.selectors.prevButton)[0];
		}

		const instance = new Swiper($products, {
			modules: [Navigation],
			loop: false,
			slidesPerView: slidesPerView,
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
			},
		});
		this._sliderInstances.push(instance);
		return instance;
	},

	async onAddToCartClick(event) {
		const { classes, selectors } = this.options;
		const $product = $(event.currentTarget).closest(selectors.product);
		const sku = String($(event.currentTarget).attr('data-sku'));
		const productName = $product.data('product-name');
		const productImage = $product.find('img').attr('src');
		const productRegularPrice = $product.find(selectors.regularPrice).text().slice(0, -1);
		const productOldPrice = $product.find(selectors.oldPrice).text().slice(0, -1);
		let quantity = $product.data('qty') || 0;

		event.preventDefault();

		quantity += 1;

		// Получаем ID корзины из куки
		let cartId = document.cookie.match(/(?:^|;\s*)cart_id=([^;]*)/)?.[1];

		// Если нет в куки, создаем новую и устанавливаем
		if (!cartId) {
			cartId = await createEmptyCart();
			document.cookie = `cart_id=${cartId}; path=/; domain=${window.location.hostname}; SameSite=Lax; Secure`; 
		}

		const result = await addProductToCart(cartId, sku, quantity);

		if (!result) {
			return;
		}

		cartQuantity += 1;
		$product.data('qty', quantity);
		this.$counter.text(cartQuantity);

		this.$productName.text(productName);
		this.$productImage.attr('src', productImage);
		this.$productOldPrice.text('');
		this.$productRegularPrice.text(this.formatPrice(productRegularPrice));

		if (productOldPrice) {
			this.$productOldPrice.text(this.formatPrice(productOldPrice));
		}

		this.$productNotification.addClass(classes.show);
	},

	async getProductsPrice() {
		const { selectors } = this.options;
		const $addToCartButtons = $(selectors.addToCart);
		const skus = [...new Set($addToCartButtons.map((_, button) => $(button).attr('data-sku')).get().filter(Boolean))];

		const products = await getProducts(skus);
		const prices = await getMindboxPrices(products);

		this._pricesCache = prices;

		products.forEach(product => {
			const priceInfo = prices[product.sku];

			if (!priceInfo) {
				return;
			}

			const $button = $addToCartButtons.filter(`[data-sku="${product.sku}"]`);
			const $product = $button.closest(selectors.product);
			const $regularPrice = $product.find(selectors.regularPrice);
			const $oldPrice = $product.find(selectors.oldPrice);
			const basePrice = priceInfo.basePrice;
			const finalPrice = priceInfo.finalPrice ?? priceInfo.basePrice;

			$regularPrice.text(this.formatPrice(finalPrice));

			if (basePrice > finalPrice) {
				$oldPrice.text(this.formatPrice(basePrice));
			}

			if (product.stock_status === 'IN_STOCK') {
				$button.show();
			}
		});
	},

	onCloseButtonClick() {
		this.$productNotification.removeClass(this.options.classes.show);
	}
});
